import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=f9ac8b4e&scoped=true"
import script from "./table-head.vue?vue&type=script&lang=js"
export * from "./table-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ac8b4e",
  null
  
)

export default component.exports